define('model/review.person.model',['require','exports','module','fukit','fukit'],function(require ,exports, module){
  var BaseModel      = require('fukit').BaseModel;
  var BaseCollection = require('fukit').BaseCollection;

  var ReviewPersonModel = BaseModel.extend(
    {
      radioRequests: {
          'models ReviewPersonModel': '@constructor',
      },

      virtual: {
        fullName: {
          deps: ['firstName', 'lastName'],
          get: function() {
            var joiningString = this.get('firstName') && this.get('lastName') ? ' ' : '';

            return (this.get('firstName') || '') + joiningString + (this.get('lastName') || '');
          },
        },
        lastNameFirstName: {
          deps: ['firstName', 'lastName'],
          get: function() {
            var joiningString = this.get('firstName') && this.get('lastName') ? ', ' : '';

            return (this.get('lastName') || '') + joiningString + (this.get('firstName') || '');
          }
        }
      },
    },

    {
      Collection: BaseCollection.extend({
        url: 'api/v2/coi/disclosure/reviewer/persons',

        parse: function(response) {
          return response;
        }
      })
    }
  )
  module.exports = ReviewPersonModel;
});

